import './Footer.css'

const Footer = () => (
  <footer className='footer'>
  <hr className='footer__line'/>
    ©2025 All rights reserved - Hafsa Sajid
  </footer>
)

export default Footer
